<template>
  <div class="course_table grey loading_table">
    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
    <b-table
      default-sort="surname"
      ref="table"
      pagination-simple
      per-page="15"
      :data="filteredUsersList"
      paginated
      checkable
      :checked-rows.sync="rows.checked"
      @page-change="changePage"
      @sort="initSort"
      backend-sorting
      backend-pagination
      :total="totalCount"
      detailed
      :show-detail-icon="false"
      @click="openInfo"
    >
      <template slot-scope="props">
        <b-table-column
          label="ФИО"
          :visible="true"
          field="surname"
          :centered="false"
          sortable
          :width="userRole === 'leader_admin' ? '25%' : '30%'"
        >
          <div>{{ props.row.surname }} {{ props.row.name }} {{ props.row.patronymic }}</div>
        </b-table-column>
        <b-table-column
          v-if="userRole === 'leader_admin'"
          label="Роль"
          :visible="true"
          field="rolename"
          :centered="false"
          sortable
          width="15%"
        >
          <div>{{ props.row.rolename }}</div>
        </b-table-column>
        <b-table-column
          label="Должность"
          :visible="true"
          field="position"
          :centered="false"
          sortable
          :width="userRole === 'leader_admin' ? '20%' : '25%'"
        >
          <div>{{ props.row.position }}</div>
        </b-table-column>
        <b-table-column
          label="Зарегистрирован"
          :visible="true"
          field="created_at"
          :centered="false"
          sortable
          width="15%"
        >
          <div>{{ props.row.created_at | moment('DD.MM.YYYY') }}</div>
        </b-table-column>
        <b-table-column
          label="Логин"
          :visible="true"
          field="email"
          :centered="false"
          sortable
          :width="userRole === 'leader_admin' ? '20%' : '25%'"
        >
          <div>{{ props.row.email }}</div>
        </b-table-column>
      </template>
      <template slot="detail" slot-scope="props">
        <div class="table_actions">
          <button
            class="delete_course"
            @click="$emit('delete', props.row.id)"
            v-if="!props.row.deleted_at && userRole != 'leader'"
          >
            <i class="mdi mdi-account-remove-outline"></i> В архив
          </button>
          <button
            class="restore_course"
            @click="$emit('restore', props.row.id)"
            v-if="props.row.deleted_at && userRole != 'leader'"
          >
            <i class="mdi mdi-account-check-outline"></i> Восстановить
          </button>
          <button
            class="double_course"
            v-if="!props.row.deleted_at && userRole != 'leader'"
            @click="openUserEdit(props.row)"
          >
            <router-link :to="'/users/' + props.row.id">
              <i class="mdi mdi-account-edit"></i> Редактировать/смотреть профиль
            </router-link>
          </button>
          <button
            class="double_course"
            v-if="!props.row.deleted_at && userRole === 'leader'"
            @click="openUserEdit(props.row)"
          >
            <router-link :to="'/users/' + props.row.id">
              <i class="mdi mdi-account-edit"></i> Просмотреть профиль
            </router-link>
          </button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    usersList: {
      default: () => [],
      type: Array
    },
    rows: {
      default: () => {},
      type: Object
    },
    totalCount: {
      default: () => 0,
      type: Number
    },
    isLoading: {
      default: () => true,
      type: Boolean
    }
  },
  data() {
    return {
      openedRow: {}
    }
  },
  methods: {
    initSort(fieldName, sortType) {
      this.$emit('init-sort', fieldName, sortType)
    },
    openInfo(row) {
      if (row != this.openedRow) {
        this.$refs.table.toggleDetails(this.openedRow)
        this.$refs.table.toggleDetails(row)
        this.openedRow = row
        return
      }
      this.$refs.table.toggleDetails(row)
      this.openedRow = {}
    },
    changePage(val) {
      this.$emit('changePage', val)
    },
    openUserEdit(val) {
      if (this.$browserDetect.isIE) {
        this.$router.push('/users/' + val.id)
      }
    }
  },
  computed: {
    userRole() {
      return this.$store.state.auth.role[0]
    },
    filteredUsersList() {
      let filteredData = []
      this.usersList.forEach((user) => {
        user['rolename'] = user.roles ? this.$dictionary(user.roles[0].id) : ''
        filteredData.push(user)
      })
      return filteredData
    }
  }
}
</script>
